import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { DirectivesModule } from 'src/app/commons/directives/directives.module';
import { MenuComponent } from '../../shared/menu/menu.component';
import { HeaderDataComponent } from '../header-data/header-data.component';
import { TableComponent } from '../table/table.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { HeaderComponent } from './header/header.component';
import { LoadingComponent } from './loading/loading.component';
import { CustomMatPaginatorIntl } from './paginator/paginator';
import { SidenavComponent } from './sidenav/sidenav.component';
import { FooterComponent } from './footer/footer.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ContractSigningComponent } from 'src/app/modules/new-contract-pymes/contract-signing/contract-signing.component';
import { DigitalDialogComponent } from 'src/app/modules/new-contract-pymes/contract-signing/digital-dialog/digital-dialog.component';
import { PaperDialogComponent } from 'src/app/modules/new-contract-pymes/contract-signing/paper-dialog/paper-dialog.component';
import {
  PaperSentDialogComponent
} from 'src/app/modules/new-contract-pymes/contract-signing/paper-sent-dialog/paper-sent-dialog.component';
import { SentDialogComponent } from 'src/app/modules/new-contract-pymes/contract-signing/sent-dialog/sent-dialog.component';

const exportComponents = [
  HeaderComponent,
  SidenavComponent,
  LoadingComponent,
  CustomSelectComponent,
  TableComponent,
  HeaderDataComponent,
  MenuComponent,
  FooterComponent,
  ContractSigningComponent,
  DigitalDialogComponent,
  PaperDialogComponent,
  PaperSentDialogComponent,
  SentDialogComponent
];
@NgModule({
  declarations: [...exportComponents, FooterComponent],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    MatSidenavModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatButtonModule,
    MatSortModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatPaginatorModule,
    MatMenuModule,
    MatTooltipModule,
    MatCheckboxModule,
    DirectivesModule
  ],
  exports: exportComponents,
  schemas: [NO_ERRORS_SCHEMA],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }]
})
export class UiModule { }
